module.exports = "<div class=\"sgc-page\">\n\t<sg-carousel [slides]=\"sections\"></sg-carousel>\n</div>\n"